<section class="container-lg">
  <article class="row flex-row">
    <div class="col-12 col-lg-6 image-wrapper">
      <mb-image [media]="pressKitSection.image"></mb-image>
    </div>

    <div class="container-sm col-12 col-lg-6 content-wrapper">
      <div class="row">
        <div class="col-12 content">
          <div class="section-location-date copy-s">
            <span>{{ pressKitSection.pressKit.location }}</span>
            <span>, {{ pressKitSection.pressKit.displayDate | localizedDate: 'longDate' }}</span>
          </div>
          <h3>{{ pressKitSection.title }}</h3>
          <div
            *ngIf="pressKitSection.pressKit.fuelLabel"
            [innerHTML]="pressKitSection.pressKit.fuelLabel"
            class="copy-s fuel-label"
          ></div>
          <div class="copy-l content-text" [innerHTML]="pressKitSection.pressKit.content"></div>
          <button
            routerLink="{{ '/press-kit/' + pressKitSection.pressKit.id }}"
            class="btn btn-secondary btn-read-more"
          >
            {{ 'READ_MORE' | translate }}
          </button>
          <div class="section-footer">
            <ul *ngIf="pressKitSection.metaItems?.length" class="meta-items">
              <ng-container *ngFor="let item of pressKitSection.metaItems">
                <li *ngIf="item.count" class="meta-item">
                  {{ item.label | translate: { count: item.count } }}
                </li>
              </ng-container>
            </ul>
            <mb-action-container
              [buttonItems]="defaultActions"
              [resource]="pressKitSection.pressKit"
            ></mb-action-container>
          </div>
        </div>
      </div>
    </div>
  </article>
</section>
